export const STICKY_COLOR_MAP = {
  butter: { bg: '#fef08a', ink: '#422006', tape: 'rgba(255,255,255,0.45)' },
  peach: { bg: '#fdba74', ink: '#7c2d12', tape: 'rgba(255,255,255,0.4)' },
  mint: { bg: '#86efac', ink: '#14532d', tape: 'rgba(255,255,255,0.4)' },
  sky: { bg: '#7dd3fc', ink: '#0c4a6e', tape: 'rgba(255,255,255,0.4)' },
  lilac: { bg: '#d8b4fe', ink: '#581c87', tape: 'rgba(255,255,255,0.4)' },
  rose: { bg: '#fda4af', ink: '#881337', tape: 'rgba(255,255,255,0.4)' },
};

export const STICKY_COLOR_KEYS = Object.keys(STICKY_COLOR_MAP);

export function stickyStyle(colorKey) {
  return STICKY_COLOR_MAP[colorKey] || STICKY_COLOR_MAP.butter;
}
